import React from "react";
import './Skill.css';

function Skill(props) {
  return (
    <h3 className={`skill${props.highlighted ? ' highlight' : ''}`} selectionid={props.id} typeselected='position'>{props.name}</h3>
  );
}

export default Skill;